import React, { useContext } from 'react';
import { usePointedTime } from 'utils/components/TimeSeriesChart/timepoint';
import { useWidgetContext } from 'widgets/WidgetContext';
import { getItemTimeOrLastItem } from 'utils/timeseries/timeSeriesUtils';
import { PerfVsIndexData } from 'widgets/perfVsIndexCapsule/perfVsIndexCapsuleData';
import { getActualValue } from 'utils/interpolation';
import AppContext from 'app/AppContext';
import classNames from 'classnames';

interface PerfVsIndexCapsuleChartHeaderProps {
    data: PerfVsIndexData;
}

export function PerfVsIndexCapsuleChartHeader(
    props: PerfVsIndexCapsuleChartHeaderProps
) {
    const {
        data: { timeSeries, lastNotNilItem },
    } = props;
    const { numberFormat } = useContext(AppContext);

    const { widgetKey } = useWidgetContext();

    let relToIndexValue = lastNotNilItem
        ? numberFormat.n4(
              getActualValue(lastNotNilItem.relativePerfOrderToIndex)
          )
        : '';
    let indexValue = lastNotNilItem
        ? numberFormat.n4(getActualValue(lastNotNilItem.relativePerfIndex))
        : '';

    const time = usePointedTime('PerfVsIndexCapsuleChartHeader' + widgetKey);

    if (time !== undefined) {
        const item = getItemTimeOrLastItem(timeSeries, time);
        if (item?.relativePerfOrderToIndex) {
            relToIndexValue = numberFormat.n4(
                getActualValue(item.relativePerfOrderToIndex)
            );
        }
        if (item?.relativePerfIndex) {
            indexValue = numberFormat.n4(
                getActualValue(item.relativePerfIndex)
            );
        }
    }

    const relToIndexValueLabel = relToIndexValue ? relToIndexValue + '%' : '';
    const indexValueLabel = indexValue ? indexValue + '%' : '';
    const relToIndexClasses = classNames(
        'value',
        'rel-index-value',
        relToIndexValue.startsWith('-') ? 'neg' : 'pos'
    );

    return (
        <div className="PerfVsIndexCapsuleChartHeader">
            <div className="value index-value">{indexValueLabel}</div>
            <div className={relToIndexClasses}>{relToIndexValueLabel}</div>
        </div>
    );
}
